<template>
  <div @click="submit" ref="buttonChild_ref">
    <div
      class="waitTips"
      v-if="
        buttonData.triggerNum > 0 && payLoading && buttonData.loading === false
      "
    >
      {{ $t("components_confirmPay_btn.waitingTips") }}
      {{ timeStatus ? timeStatus : "" }}
    </div>
    <button
      class="button"
      :disabled="disabled"
      :class="{
        loadingDisabled: this.buttonData.triggerNum >= 1 && loadingDisabled,
      }"
      v-else
    >
      <slot v-if="buttonData.customName" />
      <div style="display: flex; align-items: center" v-else>
        <p>
          {{ $t(buttonName) + "" }}
          <span>{{ timeStatus ? timeStatus : "" }}</span>
        </p>
      </div>
      <i v-if="buttonData.loading" class="el-icon-loading loadingIcon"></i>
      <span v-if="buttonData.triggerNum < 1">
        <i v-if="buttonData.loading" class="el-icon-loading loadingIcon"></i>
        <img
          v-else
          class="rightIcon"
          src="../assets/images/direction-icon/button-right-icon.svg"
          alt=""
        />
      </span>
    </button>
  </div>
</template>

<script>
/**
 * 确认订单按钮组件 可查询订单状态
 * buttonData.agreement === 1 支付
 * buttonData.agreement >1 查询支付状态
 * buttonData.customName 自定义按钮名称状态
 * buttonData.type 确认支付后是否展示其他文案
 * @returns {Promise<void>}
 */
import { mapState } from "vuex";

export default {
  name: "Button",
  props: {
    buttonData: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    loadingDisabled: {
      type: Boolean,
      default: null,
    },
    timeStatus: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      buttonName: "nav.ConfirmPayment", // Confirm Payment ｜ I have completed the payment
    };
  },
  computed: {
    ...mapState("buyNftOrder", {
      payMethodInfo: (state) => state.payMethodInfo,
    }),
    payLoading() {
      if (
        [
          "201",
          "202",
          "203",
          "205",
          "206",
          "207",
          "208",
          "209",
          "10009",
          "10005",
          "10006",
        ].includes(this.payMethodInfo.payWayCode)
      ) {
        return false;
      }
      return true;
    },
    ...mapState("public", {
      payPageback_limit: (state) => state.payPageback_limit,
    }),
  },
  watch: {
    buttonData: {
      deep: true,
      immediate: true,
      handler(val) {
        //val.loading === true &&
        if (
          val.triggerNum > 0 &&
          val.customName === false &&
          this.buttonData.type !== "baht"
        ) {
          // this.buttonName = this.$t('nav.queryOderState');
          // this.buttonName = "Waiting for your payment";
        }
      },
    },
  },
  methods: {
    submit() {
      this.disabled ? "" : (this.buttonData.triggerNum += 1);
      if (this.buttonData.triggerNum === 1) {
        this.buttonData.loading = true;
        // if(this.buttonData.customName === false && this.buttonData.type !== 'baht'){
        //   this.buttonName = "Waiting for your payment";
        // }
        return;
      }
      //新打开tab跳外链接无弹框功能
      if (
        this.buttonData.type &&
        this.buttonData.type === "baht" &&
        this.payPageback_limit
      ) {
        // this.$parent.$parent.tipsState = true;
        // this.$parent.$parent.BuyTimeOut = '';
        return;
      }
      // if(this.buttonData.triggerNum > 1 && this.buttonData.customName === false && this.payPageback_limit){
      //   this.$parent.$parent.BuyTimeOut = '';
      //   this.$parent.$parent.tipsState = true;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.waitTips {
  font-family: Medium;
  font-weight: 500;
  font-size: 0.23rem;
  line-height: 0.29rem;
  color: #0059da;
  text-align: center;
}

.button {
  width: 100%;
  height: 0.58rem;
  background: linear-gradient(88.06deg, #0059da 0%, #1bb2f2 100%);
  border-radius: 0.29rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.17rem;
  font-family: Regular;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  border: none;
  .rightIcon {
    width: 0.24rem;
    margin-left: 0.08rem;
  }
  .loadingIcon {
    font-size: 0.24rem;
    margin-left: 0.08rem;
  }
}
.button[disabled] {
  opacity: 0.25;
  cursor: no-drop;
}
.loadingDisabled {
  cursor: no-drop !important;
  opacity: 0.25 !important;
}

.continue {
}
.continue:disabled {
  opacity: 0.25;
  cursor: no-drop;
}
</style>
